import React from 'react'
import { useNotificationStartup } from './hooks/useNotificationStartup'
import { Button, Modal } from '@tecsinapse/cortex-react'

export const NotificationLayer = () => {
  const { showModal, setShowModal } = useNotificationStartup()

  const onClose = () => {
    setShowModal(false)
  }

  return (
    <Modal
      open={showModal}
      onClose={onClose}
    >
      <div className='flex flex-col w-[300px] justify-center items-center'>
        <p className='font-bold text-h3 text-primary-dark mb-deca'>Receba notificações</p>
        <p className='mb-deca'>
          Ative as notificações do navegador para uma experiência ainda mais conectada e prática no Wingo.
        </p>
        <Button
          className='w-full'
          onClick={onClose}
        >
          <p>Entendido</p>
        </Button>
      </div>
    </Modal>
  )
}
